import MainLayout from "@/components/layout/admin/MainLayout.vue";
import RegionJson from "@/assets/json/region.json";
import axios from "axios";

export default {
    name: "CompanyDetail",
    components: {
        MainLayout
    },

    data() {
        return {
            company: {
                company_logo: "",
                company_name: "",
                email: "",
                phone_number: "",
                address: "",
                town: "",
                region: "",
                company_detail: ""
            },
            jobList: {},
            regionArr: RegionJson
        };
    },

    methods: {
        getCompanyDetail() {
            axios.get("/company/detail/" + this.$route.params.id)
                .then(response => {
                    this.company = response.data;
                })
                .catch(error => {
                    console.log("Company Detail API Error", error);
                });
        },

        getCompanyJobInfo() {
            axios.get("company/job/detail/" + this.$route.params.id )
                .then(response => {
                    this.jobList = response;
                })
                .catch(error => {
                    console.log("Job Info API Error", error);
                });
        },
    },

    created() {
        this.getCompanyDetail();
        this.getCompanyJobInfo();
    }
};